import { __decorate, __metadata } from "tslib";
import { DefaultExposeGroupEnum } from '@goparrot/common';
import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
export class ReadIsLoyaltyProgramAvailableDto {
}
__decorate([
    Expose({ groups: [DefaultExposeGroupEnum.READ] }),
    ApiProperty({ description: 'Available points', type: () => Number }),
    __metadata("design:type", Number)
], ReadIsLoyaltyProgramAvailableDto.prototype, "availablePoints", void 0);
__decorate([
    Expose({ groups: [DefaultExposeGroupEnum.READ] }),
    ApiProperty({ description: 'Loyalty program ID', type: () => String }),
    __metadata("design:type", String)
], ReadIsLoyaltyProgramAvailableDto.prototype, "programUuid", void 0);
//# sourceMappingURL=ReadIsLoyaltyProgramAvailableDto.js.map